import auditHttpService from '../_services/auditHttpServices'
import { GET_ALL_USERS, GET_AUDIT_DATA } from './mutation-types'

export default {
  listarUsuarios: async ({ commit }) => {
    try {
      const response = await auditHttpService.getUsers()
      commit(GET_ALL_USERS, response.data)
    } catch (e) {
      console.log(e.message)
    }
  },

  gerarDadosAuditoria: async ({ commit }, form) => {
    try {
      const response = await auditHttpService.gerarAuditoria(form)
      commit(GET_AUDIT_DATA, response.data)
    } catch (e) {
      console.log(e.message)
    }
  },
}
